import classNames from "classnames";

import useBoolean from "../hooks/useBoolean";

import heteroIcon from "../assets/images/icons/category_hetero.png";
import gayIcon from "../assets/images/icons/category_gay.png";
import transIcon from "../assets/images/icons/category_trans.png";
import chevronDown from "../assets/images/icons/chevron-down-outline.svg";

export interface Category {
    icon: string;
    text: string;
}

export const categories = {
    hetero: {
        icon: heteroIcon,
        text: "Hétero",
    } as Category,

    gay: {
        icon: gayIcon,
        text: "Gay",
    } as Category,

    trans: {
        icon: transIcon,
        text: "Trans",
    } as Category,
} as const;

export type CategoryType = keyof typeof categories;

export interface CategorySelectProps {
    categoryType: CategoryType;
    setCategoryType: (categoryType: CategoryType) => void;
    className?: string;
}

export default function CategorySelect({
    categoryType,
    setCategoryType,
    className,
}: CategorySelectProps) {
    const [isOpen, open, close] = useBoolean();
    const category = categories[categoryType as CategoryType];

    return (
        <div className={classNames(className, "relative")}>
            <button
                aria-label="Abrir menu de categorias"
                className={classNames(
                    "flex w-full items-center justify-center gap-1 px-2 py-2  pl-4 hover:bg-xv-bg-1 hover:brightness-90"
                )}
                onClick={isOpen ? close : open}
            >
                <img
                    className="h-5"
                    src={category.icon}
                    alt={"Ícone de categoria " + category.text}
                />
                <span>{category.text}</span>
                <img
                    className={classNames("w-4 transition-all", {
                        "rotate-180": isOpen,
                    })}
                    src={chevronDown}
                    alt=""
                />
            </button>
            {isOpen ? (
                <div className="absolute top-[calc(100%+20px)] left-0 z-10 flex w-full flex-col rounded-md rounded-t-none border-t-0 border-xv-border-color bg-xv-bg-2 text-center">
                    {Object.entries(categories).map(
                        ([categoryType, category], i) => (
                            <button
                                className="flex w-full items-center justify-center gap-1 border border-xv-border-color py-2 text-center hocus:brightness-90 md:p-1 md:text-left"
                                key={i}
                                onClick={() => {
                                    close();
                                    setCategoryType(
                                        categoryType as CategoryType
                                    );
                                }}
                            >
                                <img
                                    className="h-5"
                                    src={category.icon}
                                    alt={"Ícone " + category.text}
                                />
                                <span>{category.text}</span>
                            </button>
                        )
                    )}

                    <div className="absolute right-1 -top-5">
                        <div className="inline-block w-8 overflow-hidden">
                            <div className=" h-4 w-4 origin-bottom-left rotate-45 transform border border-xv-border-color bg-xv-bg-2"></div>
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
}
